import { combineReducers } from 'redux'
import locationReducer from './location'
import notificationReducer from './notifications'
import authReducer from './auth.js'
import reference from './reference'


export const makeRootReducer = (asyncReducers) => {
	return combineReducers({
		location: locationReducer,
		notifications: notificationReducer,
		auth: authReducer,
		reference: reference,
		...asyncReducers
	})
}

export const injectReducer = (store, { key, reducer }) => {
	if (Object.hasOwnProperty.call(store.asyncReducers, key)) return

	store.asyncReducers[key] = reducer
	store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export default makeRootReducer



// WEBPACK FOOTER //
// ./src/store/reducers.js